<div class="d-flex flex-column flex-fill p-1">
  <div class="border border-bottom-0 rounded rounded-bottom-0 bg-100">
    <div class="d-flex justify-content-between p-1">
      <div class="d-flex gap-1">
        @if (createOperator()) {
          <button type="button" class="btn btn-sm btn-success" (click)="create()">
            <i class="fa fa-plus fa-fw"></i> New
          </button>
        }
        @if (updateOperator()) {
          <button type="button" class="btn btn-sm btn-secondary" (click)="update()" [disabled]="!rowSelected">
            <i class="fa fa-edit fa-fw"></i> Edit
          </button>
        }
        @if (detailsOperator()) {
          <button type="button" class="btn btn-sm btn-secondary" (click)="showDetails()" [disabled]="!rowSelected">
            <i class="fa fa-eye fa-fw"></i> View
          </button>
        }
        @if (deleteOperator()) {
          <button type="button" class="btn btn-sm btn-danger" [disabled]="removing || !rowSelected" (click)="remove()">
            <div class="d-flex justify-content-center align-items-center gap-2">
              @if (removing) {
                <div>
                  <i class="fa-solid fa-circle-notch fa-spin fa-fw"></i>
                </div>
              }
              <div><i class="fa fa-trash fa-fw"></i> Delete</div>
            </div>
          </button>
        }
        @if (submitOperator()) {
          <button type="button" class="btn btn-sm btn-warning" [disabled]="submitting" (click)="submit()">
            <div class="d-flex justify-content-center align-items-center gap-2">
              @if (submitting) {
                <div>
                  <i class="fa-solid fa-circle-notch fa-spin fa-fw"></i>
                </div>
              }
              <div><i class="fa fa-check fa-fw"></i> Submit</div>
            </div>
          </button>
        }
      </div>
      <button type="button" class="btn btn-sm btn-light" (click)="loadData()">
        <i class="fa fa-refresh fa-fw"></i>
      </button>
    </div>
  </div>
  <ag-grid-angular
    class="ag-theme-balham flex-fill"
    [defaultColDef]="defaultColDef"
    [columnDefs]="columnDefs()"
    [paginationPageSizeSelector]="false"
    [rowSelection]="rowSelection"
    [pagination]="true"
    [autoSizeStrategy]="{ type: 'fitGridWidth' }"
    (gridReady)="gridReady($event)"
    (rowDoubleClicked)="rowDoubleClicked()"
    (selectionChanged)="selectionChanged($event)"
    (cellClicked)="cellClicked($event)"
    (cellValueChanged)="cellValueChanged($event)" />
</div>
